interface TreatmentMemoRoleFlags {
  isSuperAdminRole?: boolean;
  isDoctorRole?: boolean;
  isCSRole?: boolean;
}

/**
 * No.198: the memo on a 治療履歴 log is limited to Sadmin / doctor / CS — the
 * client confirmed that reading, editing and clearing it all share the same
 * three roles. clinic_admin and pharmacist can open the history but must not
 * see the memo at all, and the API leaves the `memo` key out of their response.
 */
export function canAccessTreatmentMemo(
  currentUser: TreatmentMemoRoleFlags | null | undefined,
): boolean {
  return !!(
    currentUser?.isSuperAdminRole
    || currentUser?.isDoctorRole
    || currentUser?.isCSRole
  );
}
